import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

// https://angular.io/guide/http-request-data-from-server
export enum ResponseType {
  ARRAY_BUFFER = 'arraybuffer',
  BLOB = 'blob',
  JSON = 'json',
  TEXT = 'text'
}

@Injectable()
export abstract class ApiServiceAbstract {
  protected constructor(protected http: HttpClient) {
  }

  get<T>(url: string, options: {} = { withCredentials: true }): Observable<T> {
    return this.http.get<T>(url, options);
  }

  post<T>(url: string, payload: any | null, options: {} = { withCredentials: true }): Observable<T> {
    return this.http.post<T>(url, payload, options);
  }

  put<T>(url: string, payload: any | null, options: {} = { withCredentials: true }): Observable<T> {
    return this.http.put<T>(url, payload, options);
  }

  delete<T>(url: string, options: {} = { withCredentials: true }): Observable<T> {
    return this.http.delete<T>(url, options);
  }

}